/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { UserResetPasswordVerifyResponse } from '../entities/UserResetPasswordVerifyResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const userResetPasswordVerifyResponseSchema = z.object({
  access_token: z.string(),
}) as unknown as ToZod<UserResetPasswordVerifyResponse>